import React, { useContext, useEffect, useReducer, useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { updateSetupData } from "../../../graphql/reloadyard/custom-mutations";
import {
  useEditController,
  useNotify,
  useRedirect,
  DeleteButton,
  Edit,
  FormTab,
  SaveButton,
  TabbedForm,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { Box, makeStyles, Typography } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import CheckOutlinedIcon from "@material-ui/icons/CheckOutlined";

import { BackButton } from "../../../components/common/BackButton";
import YardInfo from "./newYardData/YardInfo";
import SetupContext from "./newYardData/context";
import setupReducer from "./newYardData/reducer";
import AccessAndCapacity from "./newYardData/AccessAndCapacity";
import Note from "./newYardData/Note";
import Subscription from "./newYardData/Subscription";
import { emailApprovedHTML } from "./emailApprovedHTML";
import { emailRejectedHTML } from "./emailRejectedHTML";

import { NewCustomerStatus } from "../../../utils/constants";
import { logError } from "../../../utils/appUtils";

const SetupEdit = (props) => {
  const { record } = useEditController(props);
  let initState = useContext(SetupContext);
  const [state, dispatch] = useReducer(setupReducer, initState);

  useEffect(() => {
    if (record?.setupData) {
      dispatch({ type: "UPDATE_STATE", payload: JSON.parse(record.setupData) });
      debugger;
    }
  }, [record]);

  const getSetupData = () => {
    return state;
  };

  const validateForm = (values) => {
    const validate = state.validators[0];
    let errors = validate(state.yardInfo);
    return errors;
  };

  return (
    <SetupContext.Provider value={{ state, dispatch }}>
      <Box display="block">
        <Edit
          {...props}
          actions={<SetupEditActions />}
          title={<Typography>Edit Registration</Typography>}
          mutationMode="pessimistic"
        >
          {
            <TabbedForm
              submitOnEnter={false}
              toolbar={
                <SetupEditToolbar getSetupData={getSetupData} {...props} />
              }
              validate={validateForm}
            >
              <FormTab label="Business Info">
                <YardInfo />
              </FormTab>
              <FormTab label="Access and Capacity">
                <AccessAndCapacity />
              </FormTab>
              <FormTab label="Note">
                <Note />
              </FormTab>
              {record?.status > NewCustomerStatus.NEW && (
                <FormTab label="Subscription">
                  <Subscription />
                </FormTab>
              )}
            </TabbedForm>
          }
        </Edit>
      </Box>
    </SetupContext.Provider>
  );
};

const SetupEditActions = ({ basePath }) => (
  <TopToolbar>
    <BackButton basePath={basePath} />
  </TopToolbar>
);

const SaveWithSetupDataButton = ({ setSaving, ...props }) => {
  const { getSetupData, mode } = props;
  const redirect = useRedirect();
  const notify = useNotify();
  let label = "save";
  let color = "primary";
  let icon = <SaveIcon />;

  if (mode === "approve") {
    label = "Approve";
    color = "secondary";
    icon = <CheckOutlinedIcon />;
  } else if (mode === "reject") {
    label = "Reject";
    color = "primary";
    icon = <CloseOutlinedIcon />;
  }

  const sanitizeGroupName = (value) => {
    // Valid characters are [0-9a-zA-Z+-=._:/]
    return String(value ?? "")
      .replace(/[^0-9a-zA-Z+=._:/-]/g, "_")
      .replace(/_+/g, "_");
  };

  const createStripeCustomer = async (setupData) => {
    debugger;
    const customer = {
      name: setupData.yardInfo.businessName,
      email: setupData.yardInfo.email,
      phone: setupData.yardInfo.phoneNumber,
      description: setupData.yardInfo.businessName,
      address: {
        line1: setupData.yardInfo.street,
        line2: "",
        city: setupData.yardInfo.city,
        state: setupData.yardInfo.state,
        postal_code: setupData.yardInfo.zip,
        country: setupData.yardInfo.country
          ? setupData.yardInfo.country
          : "USA",
      },
    };

    const response = await API.post("transREST", "/stripe-create-customer", {
      body: customer,
    });
    debugger;
    if (response.err) {
      logError("resources:setup:SetupEdit:handleCustomer", response.err, false);
      throw response.err;
    } else {
      return response.customer.id;
    }
  };

  const handleApprove = async (setupData, data) => {
    try {
      debugger;
      const rawGroupName =
        "YARD_" +
        setupData.yardInfo.businessName.substr(0, 20).replace(/\s+/g, "_") +
        "_" +
        setupData.yardInfo.state.trim() +
        "_" +
        setupData.yardInfo.zip.trim();
      const groupName = sanitizeGroupName(rawGroupName);
      const { id, status, cognitoId } = data;
      var response = {};
      debugger;

      if (!setupData.subscription.customerId) {
        debugger;
        const customerId = await createStripeCustomer(setupData);
        setupData.subscription.customerId = customerId;
      }

      const toUpdateSetupData = {
        id,
        status,
        cognitoId,
        groups: [groupName],
        setupData: JSON.stringify(setupData),
      };
      await API.graphql(
        graphqlOperation(updateSetupData, { input: toUpdateSetupData })
      );
      debugger;

      response = await API.post("transREST", "/sendEmail", {
        body: {
          to: setupData.yardInfo.userEmail,
          bcc: ["support@transloads.co"],
          subject: "Your Transload Yard Setup is Approved",
          template: "emailTemplateSingIn.html",
          htmlContent: emailApprovedHTML(
            setupData.yardInfo.firstName,
            setupData.yardInfo.userEmail,
            setupData.yardInfo.businessName
          ),
          groupName,
        },
      });

      if (response.status === "success") {
        notify(`Yard successfully Approved.`);
      } else {
        notify("ERROR sending Email / creating group.", "error");
        logError(
          "setup:SetupEdit:handleApprove:response:" + JSON.stringify(response),
          response,
          false
        );
      }
    } catch (error) {
      if (response.status === "success") {
        notify("ERROR updating DB Setup Data.", "error");
        logError(
          "setup:SetupEdit:handleApprove: catch updating DB Setup Data",
          error,
          false
        );
      } else {
        notify("ERROR sending Email, creating group.", "error");
        logError(
          "setup:SetupEdit:handleApprove: catch send Email, create group",
          error,
          false
        );
      }
    }
  };

  const handleReject = async (setupData) => {
    debugger;
    try {
      const response = await API.post("transREST", "/sendEmail", {
        body: {
          to: setupData.yardInfo.userEmail,
          bcc: ["support@transloads.co"],
          subject: "Your transloads.co registration update",
          template: "emailTemplateSingIn.html",
          htmlContent: emailRejectedHTML(
            setupData.yardInfo.firstName,
            setupData.yardInfo.businessName
          ),
        },
      });
      debugger;

      if (response.status === "success") {
        notify(`Yard successfully Rejected.`);
      } else {
        notify("ERROR sending Email.", "warning");
        logError(
          "setup:SetupEdit:handleReject:response:" + JSON.stringify(response),
          response,
          false
        );
      }
    } catch (error) {
      notify("ERROR sending Email.", "error");
      logError("setup:SetupEdit:handleReject:catch", error, false);
    }
  };

  const transform = (data) => {
    setSaving(true);
    const setupData = getSetupData();
    const setupDataJson = JSON.stringify(setupData);
    debugger;
    let { status } = data;
    data.firstName = setupData.yardInfo.firstName;
    data.lastName = setupData.yardInfo.lastName;
    data.businessName = setupData.yardInfo.businessName;
    if (mode === "approve") {
      status = NewCustomerStatus.APPROVED;
    } else if (mode === "reject") {
      status = NewCustomerStatus.REJECTED;
    }

    debugger;
    return {
      ...data,
      setupData: setupDataJson,
      status,
    };
  };

  const onSuccess = async ({ data }) => {
    try {
      if (mode === "approve") {
        debugger;
        const setupData = getSetupData();
        await handleApprove(setupData, data);
      } else if (mode === "reject") {
        const setupData = getSetupData();
        await handleReject(setupData);
      }
      redirect("/setupDatas");
    } catch (err) {
      notify("ERROR sending Email.", "error");
      logError("setup:SetupEdit:onSuccess", err, false);
    }
    setSaving(false);
    notify("Yard successfully updated.", "info");
  };

  return (
    <SaveButton
      {...props}
      label={label}
      icon={icon}
      color={color}
      variant="contained"
      transform={(data) => transform(data)}
      onSuccess={onSuccess}
    />
  );
};

const useStyles = makeStyles((theme) => ({
  actionArea: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  approveButton: {
    marginLeft: theme.spacing(2),
  },
}));

const SetupEditToolbar = ({ record, ...props }) => {
  const classes = useStyles();
  const [saving, setSaving] = useState(false);
  const setupData = props.getSetupData();

  return (
    <Toolbar {...props}>
      <div className={classes.actionArea}>
        <SaveWithSetupDataButton
          {...props}
          mode="save"
          setSaving={setSaving}
          disabled={!!props.pristine || saving}
        />
        {(record?.status === NewCustomerStatus.NEW ||
          record?.status === NewCustomerStatus.PENDING_APPROVAL) && (
          <DeleteButton record={record} {...props} />
        )}
        {record?.status !== NewCustomerStatus.APPROVED && (
          <div>
            <SaveWithSetupDataButton
              {...props}
              mode="reject"
              setSaving={setSaving}
              disabled={saving}
            />
            <SaveWithSetupDataButton
              {...props}
              mode="approve"
              setSaving={setSaving}
              disabled={
                saving ||
                !setupData.subscription ||
                !setupData.subscription.productId ||
                !setupData.subscription.trialPeriod ||
                setupData.subscription?.priceList.length === 0
              }
              className={classes.approveButton}
            />
          </div>
        )}
      </div>
    </Toolbar>
  );
};

export default SetupEdit;
